<template>
  <div style="width: 100%">
    <v-row>
      <v-col>
        <v-row>
          <h2 class="title primary--text text--darken-1 text-no-wrap mt-0 ml-2">
            FORMAÇÃO ACADÊMICA
          </h2>
        </v-row>

        <!-- tabela de escolaridade -->
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headersEscolaridades"
              :items="escolaridades"
              class="elevation-0"
            >
              <!-- header -->
              <template v-slot:top>
                <v-subheader class="pl-0">
                  <v-row no-gutters>
                    <h2
                      class="subtitle-1 grey--text text--darken-1 text-no-wrap"
                    >
                      Escolaridades:
                    </h2>
                  </v-row>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        absolute
                        color="primary"
                        dark
                        right
                        text
                        @click="openDialogCreateEscolaridade()"
                        v-on="on"
                      >
                        Adicionar
                        <v-icon class="ml-2">
                          add_circle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Clique para adicionar uma escolaridade</span>
                  </v-tooltip>
                </v-subheader>
              </template>

              <!-- período -->
              <template v-slot:[`item.periodo`]="{ item }">
                {{ getDescricaoPeriodo(item) }}
              </template>

              <!-- nível de escolaridade -->
              <template v-slot:[`item.nivelEscolaridade`]="{ item }">
                {{ item.nivelEscolaridade.descricao }}
                <v-chip
                  v-if="item.fonte"
                  class="ml-2"
                  color="success"
                  outlined
                  x-small
                >
                  Importado
                </v-chip>
              </template>

              <!-- curso -->
              <template v-slot:[`item.curso`]="{ item }">
                {{
                  item.curso
                    ? item.curso.isOutro
                      ? item.nomeCursoOutro
                      : item.curso.nome
                    : item.nomeCursoOutro
                }}
              </template>

              <!-- botões -->
              <template v-slot:[`item.actions`]="{ item }">
                <!-- editar -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="!item.fonte"
                      class="mr-2"
                      color="secondary"
                      icon
                      small
                      @click="openDialogUpdateEscolaridade(item)"
                      v-on="on"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Clique para editar a escolaridade</span>
                </v-tooltip>

                <!-- excluir -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="!item.fonte"
                      class="mr-2"
                      color="error"
                      icon
                      small
                      @click="confirmDeleteEscolaridade(item)"
                      v-on="on"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Clique para excluir a escolaridade</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-divider />

        <v-row
          class="mt-8"
          no-gutters
        >
          <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
            ÁREAS DE PESQUISA (MÁXIMO 3)
          </h2>
        </v-row>

        <!-- campo de seleção de área de pesquisa -->
        <v-row
          class="mt-0"
          dense
        >
          <v-col cols="12">
            <v-card flat>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-autocomplete
                      v-model="perfilUpdate.areasPesquisa"
                      :items="listaAreasPesquisa"
                      :rules="[
                        () => isAreasPesquisaValid || 'Informe apenas 3 áreas',
                      ]"
                      :search-input.sync="areaPesquisaSearch"
                      chips
                      class="mr-4"
                      color="primary"
                      counter
                      deletable-chips
                      item-text="nome"
                      label="Digite ou selecione as áreas"
                      placeholder="Digite para pesquisar..."
                      multiple
                      outlined
                      prepend-icon="emoji_objects"
                      required
                      return-object
                      @change="updateAreasPesquisa"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :input-value="data.selected"
                          class="chip--select-multi"
                          close
                          color="secondary"
                          search=""
                          text-color="white"
                          @click:close="removeAreaPesquisa(data.item)"
                        >
                          {{ data.item.nome }}
                        </v-chip>
                      </template>
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              A área
                              <strong class="secondary--text">
                                {{ areaPesquisaSearch }}
                              </strong>
                              não foi encontrada.
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                      <template v-slot:counter>
                        <v-chip :text-color="corAreasPesquisa">
                          <v-avatar
                            :text-color="corAreasPesquisa"
                            color="secondary"
                            left
                          >
                            <span class="white--text">{{
                              perfilUpdate.areasPesquisa.length
                            }}</span>
                          </v-avatar>
                          áreas selecionadas
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <h2 class="title primary--text text--darken-1 text-no-wrap mt-0 ml-2">
            FORMAÇÃO COMPLEMENTAR
          </h2>
        </v-row>

        <!-- lista de idiomas -->
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headersIdioma"
              :items="perfilIdiomas"
              class="elevation-0"
              hide-default-footer
              item-key="id"
            >
              <template v-slot:top>
                <v-subheader class="pl-0">
                  <v-row no-gutters>
                    <h2
                      class="subtitle-1 grey--text text--darken-1 text-no-wrap"
                    >
                      Idiomas:
                    </h2>
                  </v-row>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        absolute
                        color="primary"
                        dark
                        right
                        text
                        @click="openDialogCreatePerfilIdioma()"
                        v-on="on"
                      >
                        Adicionar
                        <v-icon class="ml-2">
                          add_circle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Clique para adicionar um idioma</span>
                  </v-tooltip>
                </v-subheader>
              </template>

              <template v-slot:[`item.nome`]="{ item }">
                {{ item.nomeIdioma }}
              </template>
              <template v-slot:[`item.compreensao`]="{ item }">
                <v-progress-linear
                  v-if="item"
                  :value="item.compreensao.valor"
                  background-color="grey lighten-2"
                  color="primary"
                  height="18"
                  rounded
                >
                  <template v-slot:default>
                    <strong class="secondary--text">{{
                      item.compreensao.descricao
                    }}</strong>
                  </template>
                </v-progress-linear>
              </template>
              <template v-slot:[`item.escrita`]="{ item }">
                <v-progress-linear
                  v-if="item"
                  :value="item.escrita.valor"
                  background-color="grey lighten-2"
                  color="primary"
                  height="18"
                  rounded
                >
                  <template v-slot:default>
                    <strong class="secondary--text">{{
                      item.escrita.descricao
                    }}</strong>
                  </template>
                </v-progress-linear>
              </template>
              <template v-slot:[`item.fala`]="{ item }">
                <v-progress-linear
                  v-if="item"
                  :value="item.fala.valor"
                  background-color="grey lighten-2"
                  color="primary"
                  height="18"
                  rounded
                >
                  <template v-slot:default>
                    <strong class="secondary--text">{{
                      item.fala.descricao
                    }}</strong>
                  </template>
                </v-progress-linear>
              </template>
              <template v-slot:[`item.leitura`]="{ item }">
                <v-progress-linear
                  v-if="item"
                  :value="item.leitura.valor"
                  background-color="grey lighten-2"
                  color="primary"
                  height="18"
                  rounded
                >
                  <template v-slot:default>
                    <strong class="secondary--text lighten-4">{{
                      item.leitura.descricao
                    }}</strong>
                  </template>
                </v-progress-linear>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mr-2"
                      color="secondary"
                      icon
                      small
                      @click="openDialogUpdatePerfilIdioma(item)"
                      v-on="on"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Clique para editar o idioma</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="error"
                      icon
                      small
                      @click="confirmDeletePerfilIdioma(item)"
                      v-on="on"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Clique para excluir o idioma</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- lista de cursos de capacitação -->
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headersCursoCapacitacao"
              :items="perfil.cursosCapacitacao"
              class="elevation-0"
              item-key="id"
            >
              <!-- título -->
              <template v-slot:top>
                <v-subheader class="pl-0">
                  <v-row no-gutters>
                    <h2
                      class="subtitle-1 grey--text text--darken-1 text-no-wrap"
                    >
                      Cursos de Capacitação:
                    </h2>
                  </v-row>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        absolute
                        color="primary"
                        dark
                        right
                        text
                        @click="openDialogCreateCursoCapacitacao()"
                        v-on="on"
                      >
                        Adicionar
                        <v-icon class="ml-2">
                          add_circle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Clique para adicionar um curso</span>
                  </v-tooltip>
                </v-subheader>
              </template>

              <!-- nível de escolaridade -->
              <template v-slot:[`item.area.nome`]="{ item }">
                {{ item.area.nome }}
                <v-chip
                  v-if="item.fonte"
                  class="ml-2"
                  color="success"
                  outlined
                  x-small
                >
                  Importado
                </v-chip>
              </template>

              <!-- carga horária -->
              <template v-slot:[`item.cargaHoraria`]="{ item }">
                {{ getDescricaoHoras(item.cargaHoraria) }}
              </template>

              <!-- período -->
              <template v-slot:[`item.periodo`]="{ item }">
                {{ formatDate(item.inicio) }} a {{ formatDate(item.termino) }}
              </template>

              <!-- botões de ação -->
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="!item.fonte"
                      class="mr-2"
                      color="secondary"
                      icon
                      small
                      @click="openDialogUpdateCursoCapacitacao(item)"
                      v-on="on"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Clique para editar o curso</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="!item.fonte"
                      color="error"
                      icon
                      small
                      @click="confirmDeleteCursoCapacitacao(item)"
                      v-on="on"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Clique para excluir o curso</span>
                </v-tooltip>
              </template>
              <template v-slot:footer>
                <v-divider />
                <v-row no-gutters>
                  <strong class="ml-4 subtitle-2 grey--text text--darken-1">
                    CARGA HORÁRIA TOTAL:
                  </strong>
                  <span class="ml-2 text-no-wrap">
                    {{ getDescricaoHoras(totalHorasCursoCapacitacao) }}
                  </span>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- interesse em ser instrutor de curso de capacitação -->
        <v-row dense>
          <v-col cols="12">
            <v-card flat>
              <v-card-text>
                <!-- havendo interesse, input para informar em que áreas -->
                <v-row>
                  <v-col
                    cols="12"
                    md="11"
                  >
                    <areas-perfil-select
                      :instrutor="perfilUpdate.instrutorCapacitacao"
                      icone="palette"
                      tipo="CAPACITACAO"
                      @confirm="(value) => saveInstrutorCapacitacao(value)"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <dialog-formacao-academica :dialog-props="dialogs.dialogEscolaridade" />
    <dialog-idioma :dialog-props="dialogs.dialogIdioma" />
    <dialog-curso-capacitacao :dialog-props="dialogs.dialogCursoCapacitacao" />

    <dialog-remove
      v-if="dialogs.dialogRemoveEscolaridade.visibilidade"
      :confirm-action="deleteEscolaridade"
      :dialog-visible="dialogs.dialogRemoveEscolaridade.visibilidade"
      :toogle-visible="toogleDialogRemoveEscolaridade"
      descricao="Você realmente deseja excluir essa escolaridade?"
    />

    <dialog-remove
      v-if="dialogs.dialogRemovePerfilIdioma.visibilidade"
      :confirm-action="deletePerfilIdioma"
      :dialog-visible="dialogs.dialogRemovePerfilIdioma.visibilidade"
      :toogle-visible="toogleDialogRemovePerfilIdioma"
      descricao="Você realmente deseja excluir esse idioma?"
    />

    <dialog-remove
      v-if="dialogs.dialogRemoveCursoCapacitacao.visibilidade"
      :confirm-action="deleteCursoCapacitacao"
      :dialog-visible="dialogs.dialogRemoveCursoCapacitacao.visibilidade"
      :toogle-visible="toogleDialogRemoveCursoCapacitacao"
      descricao="Você realmente deseja excluir esse curso?"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import DialogRemove from '@/components/DialogRemove';
import DialogFormacaoAcademica from '@/views/perfil/tabs/DialogFormacaoAcademica';
import DialogIdioma from '@/views/perfil/tabs/DialogIdioma';
import DialogCursoCapacitacao from '@/views/perfil/tabs/DialogCursoCapacitacao';
import AreasPerfilSelect from '@/components/perfil/AreasPerfilSelect';
import Data from '@/modules/data';

const perfilIdiomaRepository = RepositoryFactory.get('perfilIdioma');
const escolaridadeRepository = RepositoryFactory.get('escolaridade');
const cursoCapacitacaoRepository = RepositoryFactory.get('cursoCapacitacao');

export default {
  name: 'Formacao',

  components: {
    DialogRemove,
    DialogFormacaoAcademica,
    DialogIdioma,
    DialogCursoCapacitacao,
    AreasPerfilSelect,
  },

  props: {
    perfil: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
  },

  data() {
    return {
      perfilUpdate: {},
      curriculum: [],
      areaPesquisa: { nome: '', tipo: 'PESQUISA' },
      areaPesquisaSearch: '',
      areaCapacitacao: { nome: '' },
      areaCapacitacaoSearch: '',
      dialogs: {
        dialogEscolaridade: {
          descricao: '',
          visibilidade: false,
          valid: false,
          acao: 'cadastrar',
          item: null,
        },
        dialogIdioma: {
          descricao: '',
          visibilidade: false,
          valid: false,
          acao: 'cadastrar',
          item: null,
        },
        dialogCursoCapacitacao: {
          descricao: '',
          visibilidade: false,
          valid: false,
          acao: 'cadastrar',
          item: null,
        },
        dialogAreaCapacitacao: {
          descricao: '',
          visibilidade: false,
          valid: false,
          edicao: false,
          item: null,
        },
        dialogRemoveEscolaridade: { visibilidade: false },
        dialogRemovePerfilIdioma: { visibilidade: false },
        dialogRemoveCursoCapacitacao: { visibilidade: false },
      },
      camposRules: [(v) => (v && !!v.trim()) || 'Campo Obrigatório'],
      rules: {
        nome: [(v) => !!v || v !== '' || 'Nome obrigatório'],
      },
    };
  },

  computed: {
    ...mapState({
      competencias: (state) => state.competencia.competenciasTecnicas.filter((c) => c.unidades.length === 0),
      usuario: (state) => state.auth.usuario,
      listaAreasPesquisa: (state) => state.perfil.listaAreasPesquisa,
      listaAreasProfissional: (state) => state.perfil.listaAreasProfissional,
    }),
    perfilIdiomas() {
      return this.usuario.perfil.idiomas.slice().sort((a, b) => a.nomeIdioma.localeCompare(b.nomeIdioma));
    },
    isAreasPesquisaValid() {
      return this.perfilUpdate.areasPesquisa.length <= 3;
    },
    escolaridades() {
      return this.usuario.perfil.escolaridades.slice().sort((a, b) => a.inicio.localeCompare(b.inicio));
    },
    escolaridadesHasNomeCurso() {
      return this.usuario.perfil.escolaridades.some(
        (e) => e.nivelEscolaridade !== ''
          && e.nivelEscolaridade.id !== 'ENSINO_FUNDAMENTAL'
          && e.nivelEscolaridade.id !== 'ENSINO_MEDIO'
          && e.nivelEscolaridade.id !== 'ESPECIALIZACAO_RESIDENCIA_MEDICA',
      );
    },
    escolaridadesHasResidencia() {
      return this.usuario.perfil.escolaridades.some((e) => !!e.residenciaEm);
    },
    corAreasPesquisa() {
      return this.isAreasPesquisaValid ? 'secondary' : 'error';
    },
    headersEscolaridades() {
      const nivelEscolaridade = {
        text: 'NÍVEL',
        value: 'nivelEscolaridade',
        sortable: false,
        align: 'start',
      };
      const curso = { text: 'CURSO', value: 'curso', sortable: false };
      const residencia = { text: 'RESIDÊNCIA MÉDICA EM', value: 'residenciaEm', sortable: false };
      const instituicao = {
        text: 'INSTITUIÇÃO',
        value: 'instituicao',
        sortable: false,
        width: '15%',
      };
      const status = {
        text: 'SITUAÇÃO',
        value: 'status.descricao',
        sortable: false,
        width: '10%',
      };
      const periodo = {
        text: 'PERÍODO',
        value: 'periodo',
        sortable: false,
        width: '10%',
        align: 'center',
      };
      const actions = {
        text: 'AÇÕES',
        value: 'actions',
        sortable: false,
        width: '15%',
        align: 'center',
      };

      if (this.escolaridadesHasNomeCurso && this.escolaridadesHasResidencia) {
        return [nivelEscolaridade, curso, residencia, instituicao, status, periodo, actions];
      }
      if (this.escolaridadesHasNomeCurso && !this.escolaridadesHasResidencia) {
        return [nivelEscolaridade, curso, instituicao, status, periodo, actions];
      }
      if (!this.escolaridadesHasNomeCurso && this.escolaridadesHasResidencia) {
        instituicao.width = '25';
        return [nivelEscolaridade, residencia, instituicao, status, periodo, actions];
      }
      instituicao.width = '35%';
      periodo.width = '15%';
      return [nivelEscolaridade, instituicao, status, periodo, actions];
    },
    headersIdioma() {
      return [
        { text: 'IDIOMA', value: 'nome', align: 'start' },
        {
          text: 'COMPREENSÃO',
          value: 'compreensao',
          sortable: false,
          width: '15%',
          align: 'center',
        },
        {
          text: 'ESCRITA',
          value: 'escrita',
          sortable: false,
          width: '15%',
          align: 'center',
        },
        {
          text: 'FALA',
          value: 'fala',
          sortable: false,
          width: '15%',
          align: 'center',
        },
        {
          text: 'LEITURA',
          value: 'leitura',
          sortable: false,
          width: '15%',
          align: 'center',
        },
        {
          text: 'AÇÕES',
          value: 'actions',
          sortable: false,
          width: '15%',
          align: 'center',
        },
      ];
    },
    headersCursoCapacitacao() {
      return [
        {
          text: 'ÁREA',
          value: 'area.nome',
          sortable: false,
          width: '25%',
          align: 'start',
        },
        {
          text: 'CURSO',
          value: 'nome',
          sortable: false,
          align: 'start',
        },
        {
          text: 'INSTITUIÇÃO',
          value: 'instituicao',
          sortable: false,
          align: 'start',
        },
        {
          text: 'CARGA HORÁRIA',
          value: 'cargaHoraria',
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'PERÍODO',
          value: 'periodo',
          sortable: false,
          width: '15%',
          align: 'center',
        },
        {
          text: 'AÇÕES',
          value: 'actions',
          sortable: false,
          width: '15%',
          align: 'center',
        },
      ];
    },
    totalHorasCursoCapacitacao() {
      return this.perfil.cursosCapacitacao.reduce((acumulator, c) => acumulator + c.cargaHoraria, 0);
    },
  },

  watch: {
    perfil(value) {
      this.perfilUpdate = { ...value };
    },
    'perfilIdioma.idioma': function () {
      if (!this.perfilIdioma.id) {
        this.perfilIdioma.compreensao = this.niveisIdioma[0].id;
        this.perfilIdioma.escrita = this.niveisIdioma[0].id;
        this.perfilIdioma.fala = this.niveisIdioma[0].id;
        this.perfilIdioma.leitura = this.niveisIdioma[0].id;
      }
    },
    'escolaridade.status': function () {
      if (!this.escolaridade.id) {
        this.escolaridade.inicio = '';
        this.escolaridade.termino = '';
      }
    },
    'dialogs.dialogIdioma.visibilidade': function (value) {
      if (!value) {
        this.clearForm('idioma');
      }
    },
    'dialogs.dialogAreaCapacitacao.visibilidade': function (value) {
      if (!value) {
        this.clearForm('areaCapacitacao');
      }
    },
  },

  created() {
    this.perfilUpdate = { ...this.perfil };
  },

  methods: {
    saveInstrutorCapacitacao(instrutorCapacitacao) {
      this.perfilUpdate.instrutorCapacitacao = instrutorCapacitacao;
      this.updatePerfil();
    },
    updateAreasPesquisa() {
      if (this.isAreasPesquisaValid) {
        this.updatePerfil();
        this.areaPesquisaSearch = '';
      } else {
        this.$store.dispatch('app/error', {
          message: 'É necessário remover áreas de pesquisa até o limite de 3 itens',
        });
      }
    },
    removeAreaPesquisa(item) {
      const index = this.perfilUpdate.areasPesquisa.findIndex((a) => a.id === item.id);
      if (index !== -1) {
        this.perfilUpdate.areasPesquisa.splice(index, 1);
        this.updateAreasPesquisa();
      }
    },
    updatePerfil() {
      this.$emit('updatePerfil', this.perfilUpdate);
    },
    openDialogUpdateEscolaridade(item) {
      this.dialogs.dialogEscolaridade.escolaridade = item;
      this.dialogs.dialogEscolaridade.acao = 'editar';
      this.dialogs.dialogEscolaridade.visibilidade = true;
    },
    openDialogCreateEscolaridade() {
      this.dialogs.dialogEscolaridade.escolaridade = null;
      this.dialogs.dialogEscolaridade.acao = 'cadastrar';
      this.dialogs.dialogEscolaridade.visibilidade = true;
    },
    confirmDeleteEscolaridade(item) {
      this.dialogs.dialogRemoveEscolaridade.item = item;
      this.toogleDialogRemoveEscolaridade();
    },
    openDialogCreatePerfilIdioma() {
      this.dialogs.dialogIdioma.item = null;
      this.dialogs.dialogIdioma.acao = 'cadastrar';
      this.dialogs.dialogIdioma.visibilidade = true;
    },
    openDialogUpdatePerfilIdioma(item) {
      this.dialogs.dialogIdioma.perfilIdioma = item;
      this.dialogs.dialogIdioma.visibilidade = true;
      this.dialogs.dialogIdioma.acao = 'editar';
    },
    confirmDeletePerfilIdioma(item) {
      this.dialogs.dialogRemovePerfilIdioma.item = item;
      this.toogleDialogRemovePerfilIdioma();
    },
    openDialogCreateCursoCapacitacao() {
      this.dialogs.dialogCursoCapacitacao.item = null;
      this.dialogs.dialogCursoCapacitacao.acao = 'cadastrar';
      this.dialogs.dialogCursoCapacitacao.visibilidade = true;
    },
    openDialogUpdateCursoCapacitacao(item) {
      this.dialogs.dialogCursoCapacitacao.cursoCapacitacao = item;
      this.dialogs.dialogCursoCapacitacao.visibilidade = true;
      this.dialogs.dialogCursoCapacitacao.acao = 'editar';
    },
    confirmDeleteCursoCapacitacao(item) {
      this.dialogs.dialogRemoveCursoCapacitacao.item = item;
      this.toogleDialogRemoveCursoCapacitacao();
    },
    deleteEscolaridade() {
      if (this.dialogs.dialogRemoveEscolaridade.item.id) {
        escolaridadeRepository.delete(this.dialogs.dialogRemoveEscolaridade.item.id).then((res) => {
          const escolaridade = this.dialogs.dialogRemoveEscolaridade.item;
          const index = this.usuario.perfil.escolaridades.findIndex((e) => e.id === escolaridade.id);
          if (index !== -1) {
            this.usuario.perfil.escolaridades.splice(index, 1);
            this.toogleDialogRemoveEscolaridade();
            this.$store.dispatch('app/success', {
              response: res,
              message: 'Escolaridade excluída com sucesso!',
            });
          }
        });
      }
    },
    deletePerfilIdioma() {
      if (this.dialogs.dialogRemovePerfilIdioma.item.id) {
        perfilIdiomaRepository.delete(this.dialogs.dialogRemovePerfilIdioma.item.id).then((res) => {
          const idiomaId = this.dialogs.dialogRemovePerfilIdioma.item.id;
          const index = this.usuario.perfil.idiomas.findIndex((p) => p.id === idiomaId);
          if (index !== -1) {
            this.usuario.perfil.idiomas.splice(index, 1);
            this.toogleDialogRemovePerfilIdioma();
            this.$store.dispatch('app/success', {
              response: res,
              message: 'Idioma excluído com sucesso!',
            });
          }
        });
      }
    },
    deleteCursoCapacitacao() {
      const cursoCapacitacao = this.dialogs.dialogRemoveCursoCapacitacao.item;
      cursoCapacitacaoRepository.delete(cursoCapacitacao.id).then((res) => {
        const index = this.perfil.cursosCapacitacao.findIndex((c) => c.id === cursoCapacitacao.id);
        this.perfil.cursosCapacitacao.splice(index, 1);
        this.toogleDialogRemoveCursoCapacitacao();
        this.$store.dispatch('app/success', { response: res, message: 'Curso excluído com sucesso!' });
      });
    },
    toogleDialogRemoveEscolaridade() {
      this.dialogs.dialogRemoveEscolaridade.visibilidade = !this.dialogs.dialogRemoveEscolaridade.visibilidade;
    },
    toogleDialogRemovePerfilIdioma() {
      this.dialogs.dialogRemovePerfilIdioma.visibilidade = !this.dialogs.dialogRemovePerfilIdioma.visibilidade;
    },
    toogleDialogRemoveCursoCapacitacao() {
      this.dialogs.dialogRemoveCursoCapacitacao.visibilidade = !this.dialogs.dialogRemoveCursoCapacitacao.visibilidade;
    },
    clearForm(tipo) {
      let form = null;
      switch (tipo) {
        case 'escolaridade':
          this.escolaridade.id = null;
          this.escolaridade.inicio = '';
          this.escolaridade.termino = '';
          this.escolaridade.curso = { id: null, nome: '' };
          form = this.$refs.formEscolaridade;
          break;
        case 'areaPesquisa':
          form = this.$refs.formAreaPesquisa;
          break;
        case 'perfilIdioma':
          form = this.$refs.formPerfilIdioma;
          break;
        case 'cursoCapacitacao':
          this.cursoCapacitacao.id = null;
          this.cursoCapacitacao.inicio = '';
          this.cursoCapacitacao.termino = '';
          form = this.$refs.formCursoCapacitacao;
          break;
        case 'areaCapacitacao':
          form = this.$refs.formAreaCapacitacao;
          break;
        default:
      }

      if (form) {
        form.reset();
        form.resetValidation();
      }
    },
    formatDate(date) {
      return Data.create(date).format('MM/YYYY');
    },
    getDescricaoHoras(horas) {
      let descricao = '';
      if (!horas || horas === 0) {
        descricao += '0';
      } else if (horas === 1) {
        descricao += `${horas} hora`;
      } else {
        descricao += `${horas} horas`;
      }
      return descricao;
    },
    getDescricaoPeriodo(item) {
      if (item && item.id) {
        let descricao = '';
        if (item.status && item.status.id === 'EM_ANDAMENTO') {
          descricao += `De ${Data.format(item.inicio, 'MM/YYYY')} até hoje`;
        } else {
          descricao += `De ${Data.format(item.inicio, 'MM/YYYY')} até ${Data.format(item.termino, 'MM/YYYY')}`;
        }
        return descricao;
      }
      return '';
    },
  },
};
</script>
